import { useMemo } from 'react';
import Fuse from 'fuse.js';
import type { AccountDocumentSummaryItem, DocumentType } from '../model.ts';

type Filters = {
  keyword: string;
  documentType: DocumentType | null;
};

const useFilteredAccountDocuments = (
  records: AccountDocumentSummaryItem[],
  { keyword, documentType }: Filters,
) =>
  useMemo(() => {
    const filtered = documentType
      ? records.filter((record) => record.documentType === documentType)
      : records;

    const trimmedKeyword = keyword.trim();
    if (!trimmedKeyword) return filtered;

    const fuse = new Fuse(filtered, {
      keys: ['account.email'],
      threshold: 0.0,
      ignoreLocation: true,
    });

    return fuse.search(trimmedKeyword).map(({ item }) => item);
  }, [records, keyword, documentType]);

export { useFilteredAccountDocuments };
